var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.765,
    height: 42,
    viewBox: "0 0 53.765 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15368",
    "data-name": "Rectangle 15368",
    width: 53.765,
    height: 42,
    fill: "#002036"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35603",
    "data-name": "Group 35603",
    opacity: 0.396
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13992",
    "data-name": "Group 13992",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33578",
    "data-name": "Path 33578",
    d: "M50.424,33.48a11.489,11.489,0,0,0-5.418-19.26l-.279-.067-.078-.285A18.33,18.33,0,0,0,8.59,17l-.027.372-.374.073A9.779,9.779,0,0,0,9.78,36.87h8.11V34.412H10.032A7.613,7.613,0,0,1,4.62,32.2a7.3,7.3,0,0,1,5.2-12.43A1.23,1.23,0,0,0,11.05,18.54,15.872,15.872,0,0,1,26.905,2.653h.016a15.9,15.9,0,0,1,15.572,12.8,1.229,1.229,0,0,0,1.045.984,9.031,9.031,0,0,1-1.224,17.973H35.952V36.87h6.359a11.413,11.413,0,0,0,8.113-3.39",
    transform: "translate(0)",
    fill: "#002036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33579",
    "data-name": "Path 33579",
    d: "M192.334,198.994l3.559,3.559,1.731-1.731-6.5-6.5a1.232,1.232,0,0,0-1.731,0l-6.5,6.5,1.732,1.732,3.574-3.559a.5.5,0,0,1,.538-.11.488.488,0,0,1,.3.451v15.9H191.5V199.344a.5.5,0,0,1,.3-.46.486.486,0,0,1,.534.111",
    transform: "translate(-163.346 -173.236)",
    fill: "#002036"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.13a2c762c056b0dad04140f738be5396.svg";
export { ForwardRef as ReactComponent };